// Paleta de signatario "Campo Lavanda" — FONTE UNICA das cores por indice de signatario.
//
// O signatario N tem de ter a MESMA cor no seletor do builder, na moldura do campo, na ilha
// Shadow DOM do dynamic_area e na tela do envelope. Ate 02/09/2026 essa promessa era mantida
// por QUATRO copias literais (area.vue, dynamic_area.vue, field_submitter.vue e
// submissions/show.html.erb), cada uma com um comentario pedindo que as outras fossem
// atualizadas junto. Uma copia divergir nao quebra nada: a tela renderiza, com o signatario
// pintado de duas cores diferentes em dois lugares.
//
// Sao 10 matizes distinguiveis, saturacao harmonizada com a identidade (esmeralda = token
// success, ambar = token warning), em 3 tons coordenados por matiz:
//
//   dot    solido, para o marcador do seletor de signatario
//   border /80, para a moldura da area do campo
//   bg     fundo claro, atras do VALOR do campo — precisa continuar clarinho
//
// ⚠️ AS CLASSES SAO LITERAIS DE PROPOSITO. O JIT do Tailwind extrai candidatos por REGEX no
// texto do arquivo; ele nao avalia JavaScript. `bg-[${hex}]` nao compilaria nunca. Por isso o
// modulo guarda a classe inteira, e nao o hex.
//
// ⚠️ E POR ISSO ESTE ARQUIVO PRECISA ESTAR NO `content` DE CADA PACK QUE USA A PALETA. O pack
// `application` o pega pelo glob `./app/javascript/**/*.{js,vue}`; o `dynamic` enumera arquivos
// UM POR UM e teve de ganhar esta linha (tailwind.dynamic.config.js). Sem ela, a ilha Shadow DOM
// do template-builder sairia sem NENHUMA cor de signatario — sem erro de build e sem aviso.
//
// O gemeo Ruby e `SynexisSign::SIGNER_COLORS` (lib/synexis_sign.rb), lido pelo
// `submissions/show.html.erb`. A paridade entre os dois e guardada por
// `spec/lib/signer_colors_parity_spec.rb`.
export default [
  { dot: 'bg-[#C93A56]', border: 'border-[#C93A56]/80', bg: 'bg-[#FAE3E8]' },
  { dot: 'bg-[#2F6FC9]', border: 'border-[#2F6FC9]/80', bg: 'bg-[#E3EDFA]' },
  { dot: 'bg-[#0B8A66]', border: 'border-[#0B8A66]/80', bg: 'bg-[#DDF6EE]' },
  { dot: 'bg-[#A16B00]', border: 'border-[#A16B00]/80', bg: 'bg-[#F8EED8]' },
  { dot: 'bg-[#8B41C9]', border: 'border-[#8B41C9]/80', bg: 'bg-[#F1E6FA]' },
  { dot: 'bg-[#C2418C]', border: 'border-[#C2418C]/80', bg: 'bg-[#F9E4F1]' },
  { dot: 'bg-[#0C7F96]', border: 'border-[#0C7F96]/80', bg: 'bg-[#DFF2F6]' },
  { dot: 'bg-[#C25A1F]', border: 'border-[#C25A1F]/80', bg: 'bg-[#F9E8DC]' },
  { dot: 'bg-[#567E0F]', border: 'border-[#567E0F]/80', bg: 'bg-[#EDF4DB]' },
  { dot: 'bg-[#4F49C0]', border: 'border-[#4F49C0]/80', bg: 'bg-[#E7E6F8]' }
]
